var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_290_196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 122C94.6894 122 122 94.6894 122 61C122 27.3106 94.6894 0 61 0C27.3106 0 0 27.3106 0 61C0 94.6894 27.3106 122 61 122Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.732 87.2456H82.4766V39.5721H100.765L113.732 63.4209V87.2456Z",
    fill: "#F8B517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.433 61.7669L98.4621 43.455H86.334V61.7669H108.433Z",
    fill: "#0090FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4762 74.9258H8.26953V87.2456H82.4762V74.9258Z",
    fill: "#EA7417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5458 26.1737L94.82 21.3081L80.0554 26.5812L74.3748 34.8983H8.26953V67.2558H77.9222V38.8291L83.3631 30.8716L96.5458 26.1737Z",
    fill: "#FF9021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2214 67.2559H15.5078V74.9258H69.2214V67.2559Z",
    fill: "#D54232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2214 67.2559H15.5078V69.6287H69.2214V67.2559Z",
    fill: "#AF2C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5805 38.158C14.6937 38.158 13.9746 38.901 13.9746 39.8358V61.743C13.9746 62.6778 14.6937 63.4208 15.5805 63.4208C16.4673 63.4208 17.1864 62.6778 17.1864 61.743V39.8358C17.1864 38.901 16.4673 38.158 15.5805 38.158Z",
    fill: "#EA7711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7368 38.158C23.8499 38.158 23.1309 38.901 23.1309 39.8358V61.743C23.1309 62.6778 23.8499 63.4208 24.7368 63.4208C25.6236 63.4208 26.3426 62.6778 26.3426 61.743V39.8358C26.3426 38.901 25.6236 38.158 24.7368 38.158Z",
    fill: "#EA7711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8676 38.158C32.9808 38.158 32.2617 38.901 32.2617 39.8358V61.743C32.2617 62.6778 32.9808 63.4208 33.8676 63.4208C34.7544 63.4208 35.4735 62.6778 35.4735 61.743V39.8358C35.4735 38.901 34.7544 38.158 33.8676 38.158Z",
    fill: "#EA7711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0239 38.158C42.137 38.158 41.418 38.901 41.418 39.8358V61.743C41.418 62.6778 42.137 63.4208 43.0239 63.4208C43.9107 63.4208 44.6298 62.6778 44.6298 61.743V39.8358C44.6298 38.901 43.9107 38.158 43.0239 38.158Z",
    fill: "#EA7711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1801 38.158C51.2933 38.158 50.5742 38.901 50.5742 39.8358V61.743C50.5742 62.6778 51.2933 63.4208 52.1801 63.4208C53.0669 63.4208 53.786 62.6778 53.786 61.743V39.8358C53.762 38.901 53.0669 38.158 52.1801 38.158Z",
    fill: "#EA7711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3129 38.158C60.4261 38.158 59.707 38.901 59.707 39.8358V61.743C59.707 62.6778 60.4261 63.4208 61.3129 63.4208C62.1998 63.4208 62.9188 62.6778 62.9188 61.743V39.8358C62.9188 38.901 62.1998 38.158 61.3129 38.158Z",
    fill: "#EA7711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4692 38.158C69.5823 38.158 68.8633 38.901 68.8633 39.8358V61.743C68.8633 62.6778 69.5823 63.4208 70.4692 63.4208C71.356 63.4208 72.0751 62.6778 72.0751 61.743V39.8358C72.0751 38.901 71.356 38.158 70.4692 38.158Z",
    fill: "#EA7711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2472 97.4322C103.873 97.4322 108.434 92.8715 108.434 87.2456C108.434 81.6197 103.873 77.059 98.2472 77.059C92.6213 77.059 88.0605 81.6197 88.0605 87.2456C88.0605 92.8715 92.6213 97.4322 98.2472 97.4322Z",
    fill: "#4F5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2462 92.8062C101.317 92.8062 103.807 90.3166 103.807 87.2455C103.807 84.1744 101.317 81.6848 98.2462 81.6848C95.1752 81.6848 92.6855 84.1744 92.6855 87.2455C92.6855 90.3166 95.1752 92.8062 98.2462 92.8062Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6945 97.4322C31.3204 97.4322 35.8811 92.8715 35.8811 87.2456C35.8811 81.6197 31.3204 77.059 25.6945 77.059C20.0685 77.059 15.5078 81.6197 15.5078 87.2456C15.5078 92.8715 20.0685 97.4322 25.6945 97.4322Z",
    fill: "#4F5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6935 92.8062C28.7646 92.8062 31.2542 90.3166 31.2542 87.2455C31.2542 84.1744 28.7646 81.6848 25.6935 81.6848C22.6224 81.6848 20.1328 84.1744 20.1328 87.2455C20.1328 90.3166 22.6224 92.8062 25.6935 92.8062Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.464 97.4322C54.0899 97.4322 58.6506 92.8715 58.6506 87.2456C58.6506 81.6197 54.0899 77.059 48.464 77.059C42.8381 77.059 38.2773 81.6197 38.2773 87.2456C38.2773 92.8715 42.8381 97.4322 48.464 97.4322Z",
    fill: "#4F5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.465 92.8062C51.5361 92.8062 54.0257 90.3166 54.0257 87.2455C54.0257 84.1744 51.5361 81.6848 48.465 81.6848C45.3939 81.6848 42.9043 84.1744 42.9043 87.2455C42.9043 90.3166 45.3939 92.8062 48.465 92.8062Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.603 71.0908C110.95 71.0908 109.607 72.4331 109.607 74.0869C109.607 75.7407 110.95 77.083 112.603 77.083H113.73V71.1148H112.603V71.0908Z",
    fill: "#F1F3F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_290_196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 122,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/icon11.90d346e4a150a5a69eb4c97e10780f3d.svg";
export { ForwardRef as ReactComponent };